import React from "react";
import { useTranslation } from "react-i18next";
import useActiveSpecialistRole from "../../app/hooks/useActiveSpecialistRole";

const ImportDataSheetNote = () => {
  const { t } = useTranslation();
  const { roleKey } = useActiveSpecialistRole();
  if (roleKey === "feeder") {
    return t(
      "admin.importdata.information.term",
      "El archivo debe ser .xlsx y contener la hoja denominada: term. Descarga la plantilla de este módulo. Un campo es obligatorio y el resto es opcional."
    );
  }
  return t("admin.importdata.information");
};

export default ImportDataSheetNote;
